import { render, staticRenderFns } from "./CustomersClub.vue?vue&type=template&id=785d18ae"
import script from "./CustomersClub.vue?vue&type=script&lang=js"
export * from "./CustomersClub.vue?vue&type=script&lang=js"
import style0 from "./CustomersClub.vue?vue&type=style&index=0&id=785d18ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports